import logoSvg from './logo.svg'

export const SvgImageParceirosMetLifeLogo = ( props ) => {
    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
            <img
                className='w-full'
                width="50px"
                height="50px"
                src={logoSvg}
                alt={''}
                {...props}
            />
        </div>
    )
}